import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SidebarLayout from '../layout/SidebarLayout';
import AdminDashboard from './AdminDashboard';
import GymManager from './GymManager';
import GymCreatePage from './GymCreatePage';
import AdminGymDetailPage from './AdminGymDetailPage';
import AdminGymMonitor from './AdminGymMonitor';
import AdminUsersPage from './AdminUsersPage';
import AdminStandaloneMonitor from './AdminStandaloneMonitor';
import GymRequestsPage from './GymRequestsPage';
import ExerciseImageEditor from './ExerciseImageEditor';
import ExerciseImageErrorChecker from './ExerciseImageErrorChecker';
import ExerciseAdminPanel from './ExerciseAdminPanel';
import AdminTesterSyncMonitor from './AdminTesterSyncMonitor';
import AdminOpenWorkoutsMonitor from './AdminOpenWorkoutsMonitor';
import AppVersionsPage from '../../pages/AppVersionsPage';
import FeedbackPage from '../../pages/FeedbackPage';
import AdminPlanningBoard from './AdminPlanningBoard';
import GymSaasPlansConfig from './GymSaasPlansConfig';
import AdminTrialTemplatesPage from './AdminTrialTemplatesPage';

const ProtectedAdminPanel = () => {
    const { currentUser, loading, isAdmin, isTrainer } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!currentUser || (!isAdmin() && !isTrainer())) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Routes>
            <Route element={<SidebarLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="gyms/new" element={<GymCreatePage />} />
                <Route path="gyms/:gymId" element={<AdminGymDetailPage />} />
                <Route path="gyms" element={<GymManager />} />
                <Route path="saas-plans" element={isAdmin() ? <GymSaasPlansConfig /> : <Navigate to="/admin" replace />} />
                <Route path="planning" element={isAdmin() ? <AdminPlanningBoard /> : <Navigate to="/admin" replace />} />
                <Route path="gym-monitor" element={isAdmin() ? <AdminGymMonitor /> : <Navigate to="/admin" replace />} />
                <Route path="users" element={<AdminUsersPage />} />
                <Route path="trial-templates" element={isAdmin() ? <AdminTrialTemplatesPage /> : <Navigate to="/admin" replace />} />
                <Route path="standalone" element={isAdmin() ? <AdminStandaloneMonitor /> : <Navigate to="/admin" replace />} />
                <Route path="gym-requests" element={<GymRequestsPage />} />
                <Route path="exercise-images" element={isAdmin() ? <ExerciseImageEditor /> : <Navigate to="/admin" replace />} />
                <Route path="exercise-images-errors" element={isAdmin() ? <ExerciseImageErrorChecker /> : <Navigate to="/admin" replace />} />
                <Route path="tester-sync" element={isAdmin() ? <AdminTesterSyncMonitor /> : <Navigate to="/admin" replace />} />
                <Route path="open-workouts" element={isAdmin() ? <AdminOpenWorkoutsMonitor /> : <Navigate to="/admin" replace />} />
                <Route path="exercises" element={isAdmin() ? <ExerciseAdminPanel /> : <Navigate to="/admin" replace />} />
                <Route path="app-versions" element={isAdmin() ? <AppVersionsPage /> : <Navigate to="/admin" replace />} />
                <Route path="feedback" element={isAdmin() ? <FeedbackPage /> : <Navigate to="/admin" replace />} />
            </Route>
        </Routes>
    );
};

export default ProtectedAdminPanel;